<template>
  <div class="container mt-4">
    <TopNav> </TopNav>
    <div class="row mt-5">
      <div class="col-12 text-center" v-if="isLoading">
        <HMSpinner></HMSpinner>
      </div>
      <div class="col-12" v-else>
        <HMFileSelector
          :value="file"
          title="Import Student Subscriptions from a CSV file"
          accept="text/csv"
          @input="addFile"
        />
      </div>
      <div class="col-12">
        <h6 class="mt-3">{{ $t('DATA_IMPORT.LABEL.REQUIRED_FORMAT') }}</h6>
        <p class="required-format" v-html="description"></p>
      </div>
      <div class="col-12 mt-3">
        <h4 v-if="importCount === 0">
          {{ $t('DATA_IMPORT.TEXT.NO_IMPORTS_YET') }}
        </h4>
        <h4 v-else>
          {{ $t('DATA_IMPORT.TEXT.IMPORT_HISTORY') }}
        </h4>
        <HMPaginatedTable
          ref="importTable"
          name="data-import-subscriptions-table"
          api="dataImport/getSubscriptionsImports"
          :fields="this.tableFields"
          :query="query"
          class="mt-3"
        >
          <template slot="filename" slot-scope="{ data }">
            {{ `${data.filename}` }}
          </template>
          <template slot="status" slot-scope="{ data }">
            <div
              :class="{ pointer: data.status === 'failed' }"
              @click="openStatusMessage(data.status_msg)"
            >
              <span :class="`status ${data.status}`">
                {{ `${data.status}` }}
                <span v-if="data.status === 'failed'"
                  ><i class="fa fa-info-circle"></i
                ></span>
              </span>
            </div>
          </template>
          <template slot="created" slot-scope="{ data }">
            {{ $formatDate(data.created) }}
          </template>
        </HMPaginatedTable>
      </div>
    </div>
  </div>
</template>

<script>
import TopNav from '@/web/components/navigation/TopNav';
import DataImportErrorStatusModal from './DataImportErrorStatusModal';
import { errorToMessage } from '@/core/utils/errors';

export default {
  name: 'DataImportStudents',
  components: {
    TopNav,
  },
  computed: {
    query() {
      return {};
    },
    description() {
      return `
<span class="smaller font-weight-bold">Stripe import:</span><br/>
email,firstname,lastname,productid,expirationdate,stripescubscriptionstatus,stripesubscriptionid,stripecustomerid<br/>
"student1.lastname1@email.com","Student1","Lastname1","37226","2021-08-29","canceled", "sub_test", "cus_test"<br/>
"student2.lastname2@email.com","Student2","Lastname2","32440","2022-08-29","active", "sub_test", "cus_test"<br/>
<br/><span class="smaller font-weight-bold">PayPal import:</span><br/>
email,firstname,lastname,productid,expirationdate,paypalsubscriptionid<br/>
"student1.lastname1@email.com","Student1","Lastname1","37226","2021-08-29","paypal_sub_id1"<br/>
"student2.lastname2@email.com","Student2","Lastname2","32440","2022-08-29","paypal_sub_id2"<br/>
`;
    },
    importCount() {
      const importTableState = this.$store.state[
        'data-import-subscriptions-table'
      ];
      if (importTableState) return importTableState.res.count;
      return -1;
    },
  },
  data() {
    return {
      file: null,
      isLoading: false,
      tableFields: [
        {
          title: this.$t('DATA_IMPORT.TABLE.FILENAME'),
          name: 'filename',
          cssClass: 'text-nowrap',
        },
        {
          title: this.$t('DATA_IMPORT.TABLE.STATUS'),
          name: 'status',
          cssClass: 'text-nowrap',
        },
        {
          title: this.$t('DATA_IMPORT.TABLE.UPLOADED'),
          name: 'created',
          cssClass: 'text-nowrap',
        },
      ],
    };
  },
  methods: {
    async addFile(file) {
      this.isLoading = true;
      try {
        await this.$store.dispatch('dataImport/importsSubscriptionsCSV', file);
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('DATA_IMPORT.NOTIFICATIONS.FILE_UPLOAD_SUCCESSFUL'),
        });
        this.refreshTable();
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'File upload failed',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      } finally {
        this.isLoading = false;
      }
    },
    refreshTable() {
      this.$refs.importTable?.refresh();
    },
    openStatusMessage(statusMsg) {
      if (!statusMsg) return;
      this.$modal.show(
        DataImportErrorStatusModal,
        {
          status: statusMsg,
        },
        {
          classes: ['vm--inline-modal'],
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.required-format {
  background-color: $lightest-gray;
  border: 1px dotted $dark-gray;
  border-radius: $border-radius;
  padding: 1rem 0.5rem;
}

.status {
  &.success {
    color: $light-green;
  }
  &.failed {
    color: $coral;
  }
  &.new {
  }
  &.validated {
    color: $mustard;
  }
}

#status-modal {
  ::v-deep .vm--modal {
    display: inline-block;
    max-width: inherit;
    min-width: 650px;

    @include media-breakpoint-down(sm) {
      min-width: 80%;
    }

    @include media-breakpoint-down(xs) {
      min-width: 100%;
    }
  }
}
</style>
